/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterCardContentAddPost } from '../fn/card-content/api-master-card-content-add-post';
import { ApiMasterCardContentAddPost$Params } from '../fn/card-content/api-master-card-content-add-post';
import { apiMasterCardContentDeleteGet } from '../fn/card-content/api-master-card-content-delete-get';
import { ApiMasterCardContentDeleteGet$Params } from '../fn/card-content/api-master-card-content-delete-get';
import { apiMasterCardContentEditPost } from '../fn/card-content/api-master-card-content-edit-post';
import { ApiMasterCardContentEditPost$Params } from '../fn/card-content/api-master-card-content-edit-post';
import { apiMasterCardContentGetActiveGet } from '../fn/card-content/api-master-card-content-get-active-get';
import { ApiMasterCardContentGetActiveGet$Params } from '../fn/card-content/api-master-card-content-get-active-get';
import { apiMasterCardContentGetAllGet } from '../fn/card-content/api-master-card-content-get-all-get';
import { ApiMasterCardContentGetAllGet$Params } from '../fn/card-content/api-master-card-content-get-all-get';
import { apiMasterCardContentGetByCriteriaPost } from '../fn/card-content/api-master-card-content-get-by-criteria-post';
import { ApiMasterCardContentGetByCriteriaPost$Params } from '../fn/card-content/api-master-card-content-get-by-criteria-post';
import { apiMasterCardContentGetByIdGet } from '../fn/card-content/api-master-card-content-get-by-id-get';
import { ApiMasterCardContentGetByIdGet$Params } from '../fn/card-content/api-master-card-content-get-by-id-get';
import { CardContent } from '../models/card-content';
import { CardContentApiRespModel } from '../models/card-content-api-resp-model';
import { StringApiRespModel } from '../models/string-api-resp-model';

@Injectable({ providedIn: 'root' })
export class CardContentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterCardContentAddPost()` */
  static readonly ApiMasterCardContentAddPostPath = '/api/Master/CardContent/Add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCardContentAddPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCardContentAddPost$Response(params?: ApiMasterCardContentAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CardContentApiRespModel>> {
    return apiMasterCardContentAddPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCardContentAddPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCardContentAddPost(params?: ApiMasterCardContentAddPost$Params, context?: HttpContext): Observable<CardContentApiRespModel> {
    return this.apiMasterCardContentAddPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CardContentApiRespModel>): CardContentApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterCardContentEditPost()` */
  static readonly ApiMasterCardContentEditPostPath = '/api/Master/CardContent/Edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCardContentEditPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCardContentEditPost$Response(params?: ApiMasterCardContentEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CardContentApiRespModel>> {
    return apiMasterCardContentEditPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCardContentEditPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCardContentEditPost(params?: ApiMasterCardContentEditPost$Params, context?: HttpContext): Observable<CardContentApiRespModel> {
    return this.apiMasterCardContentEditPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CardContentApiRespModel>): CardContentApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterCardContentDeleteGet()` */
  static readonly ApiMasterCardContentDeleteGetPath = '/api/Master/CardContent/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCardContentDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCardContentDeleteGet$Response(params?: ApiMasterCardContentDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StringApiRespModel>> {
    return apiMasterCardContentDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCardContentDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCardContentDeleteGet(params?: ApiMasterCardContentDeleteGet$Params, context?: HttpContext): Observable<StringApiRespModel> {
    return this.apiMasterCardContentDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringApiRespModel>): StringApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterCardContentGetByIdGet()` */
  static readonly ApiMasterCardContentGetByIdGetPath = '/api/Master/CardContent/GetById';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCardContentGetByIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCardContentGetByIdGet$Response(params?: ApiMasterCardContentGetByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CardContent>> {
    return apiMasterCardContentGetByIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCardContentGetByIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCardContentGetByIdGet(params?: ApiMasterCardContentGetByIdGet$Params, context?: HttpContext): Observable<CardContent> {
    return this.apiMasterCardContentGetByIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CardContent>): CardContent => r.body)
    );
  }

  /** Path part for operation `apiMasterCardContentGetAllGet()` */
  static readonly ApiMasterCardContentGetAllGetPath = '/api/Master/CardContent/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCardContentGetAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCardContentGetAllGet$Response(params?: ApiMasterCardContentGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CardContent>>> {
    return apiMasterCardContentGetAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCardContentGetAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCardContentGetAllGet(params?: ApiMasterCardContentGetAllGet$Params, context?: HttpContext): Observable<Array<CardContent>> {
    return this.apiMasterCardContentGetAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CardContent>>): Array<CardContent> => r.body)
    );
  }

  /** Path part for operation `apiMasterCardContentGetActiveGet()` */
  static readonly ApiMasterCardContentGetActiveGetPath = '/api/Master/CardContent/GetActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCardContentGetActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCardContentGetActiveGet$Response(params?: ApiMasterCardContentGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CardContent>>> {
    return apiMasterCardContentGetActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCardContentGetActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCardContentGetActiveGet(params?: ApiMasterCardContentGetActiveGet$Params, context?: HttpContext): Observable<Array<CardContent>> {
    return this.apiMasterCardContentGetActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CardContent>>): Array<CardContent> => r.body)
    );
  }

  /** Path part for operation `apiMasterCardContentGetByCriteriaPost()` */
  static readonly ApiMasterCardContentGetByCriteriaPostPath = '/api/Master/CardContent/GetByCriteria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCardContentGetByCriteriaPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCardContentGetByCriteriaPost$Response(params?: ApiMasterCardContentGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CardContent>>> {
    return apiMasterCardContentGetByCriteriaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCardContentGetByCriteriaPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCardContentGetByCriteriaPost(params?: ApiMasterCardContentGetByCriteriaPost$Params, context?: HttpContext): Observable<Array<CardContent>> {
    return this.apiMasterCardContentGetByCriteriaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CardContent>>): Array<CardContent> => r.body)
    );
  }

}
